import { fromJS } from 'immutable'
import { DOCKED_SIDEBAR_DESKTOP, DOCKED_SIDEBAR_MOBILE } from './../../constants'

const initialState = fromJS({
  docked: true,
  docked_mobile: true,
})

function sidebarDockedReducer(state = initialState, action) {
  switch (action.type) {
    case DOCKED_SIDEBAR_DESKTOP:
      return state.set('docked', action.payload)
    case DOCKED_SIDEBAR_MOBILE:
      return state.set('docked_mobile', action.payload)
    default:
      return state
  }
}

export default sidebarDockedReducer



// WEBPACK FOOTER //
// ./src/reducers/sidebar/sidebar-docked-reducer.js